export default __webpack_public_path__ + "static/media/letsikringafhelbred.694fae36.jpg";